import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, Padding } from '../../..'
import { colors } from '../../../../constants'
import { mediaQuery } from '../../../utils'


export const TranslucidLayer = styled.div`
    background: none;
    box-shadow: inset 0px 2px 7px 0 #0000002b;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 420;
`

export const FlagWrapper = styled.div`
    position: absolute;
    left: 20px;
    top: 80px;
    width: 100px;
    z-index: 450;
`

export const DeviceIconWrapper = styled.div`
    width: 60px;
`
export const ScreenshotDiv = styled.div`
    width: 70px;
    height: 35px;
    margin-right: 15px;
    background-color: #f1f1f1;
`

export const CodeHeader = styled.span`
    font-size: 18px;
    font-weight: bold;
    ${mediaQuery.mobile(`
        font-size: 16px;
    `)}
`

export const SecondaryCodeHeader = styled.span`
    color: ${colors.grey};
    font-size: 15px;
    font-style: italic;
`

export const AddressHeading = styled.span`
    font-size: 35px;
    ${mediaQuery.mobile(`
    font-size: 26px;
  `)}
`

export const AddressSubHeading = styled.span`
    font-size: 20px;
    ${mediaQuery.mobile(`
    font-size: 15px;
  `)}
`

export const Address = styled.div`
    color: ${colors.grey};
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const Percentage = styled.span`
    font-size: 12px;
`

export const StoreInfo = styled(Padding)`
    box-shadow: 0px 0px 4px 0px #0002;
    height: 120px;

    ${mediaQuery.mobile(`
        height: auto;
        text-align: center;
    `)}
    z-index: 4;
`

export const BottomBoard = styled(Padding)`
    background: ${colors.bluedarkest};
    height: 100%;
    padding: 15px 15px 15px 0;

    ${mediaQuery.mobile(`
        padding: 15px;
        height: auto;
    `)}
`

export const DevicesBoard = styled.div`
    background: white;
    box-shadow: 0px 0px 4px 0px #0002;
    height: calc(100% - 72px);
`

export const NotesBoard = styled.div`
    background: white;
    box-shadow: 0px 0px 4px 0px #0002;
    height: 100%;
`

export const Icon = styled(FontAwesomeIcon)`
    ${({ color }) => (color ? `color: ${color}` : `color: ${colors.blue}`)}
`

export const CenteredPadding = styled(Padding)`
    text-align: center;
`

export const ActionGroup = styled.div`
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.5s;

    *:hover > * > & {
        opacity: 1;
        transform: translateX(0);
    }
`

export const Screenshot = styled.img`
    height: 100%;
    width: 100%;
`

export const ChannelsButton = styled(Button)`
    padding: 2px 10px;
    font-size: 14px;
`

export const NotesHeader = styled.div`
    background: ${colors.greylightest};
    color: ${colors.grey};
    display: block;
    font-size: 12px;
    font-weight: 600;
    padding: 10px 30px 10px;
    position: relative;
    text-transform: uppercase;
    width: 100%;
    height: 36px;
`

export const NotesBody = styled.div`
    font-size: 14px;
    height: calc(100% - 48px);
    padding: 0 15px;
    overflow: auto;
    margin-top: 10px;
`

export const StoreDetails = styled.div`
    height: calc(100% - 120px);

    ${mediaQuery.mobile(`
        height: auto;
    `)}
`

export const ActionLinkTitle = styled.span`
    margin-left: 5px;
    color: ${colors.red};
`

export const EmptyData = styled.span`
  color: ${colors.bluelighter}
  font-style: italic;
  opacity: 0.6;
`

export const IdCell = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 10px; /* breathing room before next column */
    min-width: 0; /* allow children to shrink for ellipsis */
`

export const IdButton = styled(Button)`
    padding: 4px 0; /* keep click target but remove right padding for consistent gap */
    font-size: 14px;
    color: ${colors.blue};
    background: transparent;
    margin-right: 0 !important; /* cancel default button spacing */
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const LoadMoreWrapper = styled.div`
    color: ${colors.grey};
    text-align: center;
    background: ${colors.greylightest};
`
export const LoadMoreHeader = styled.div`
    
`
export const Search = styled.input`
    background: ${colors.white};
    border: 1px solid #cccccc;
    border-radius: 5px;
    color: ${colors.greydark};
    font-size: 13px;
    outline: none;
    padding: 10px 5px;
    vertical-align: middle;
    transition: 0.3s all;
    margin: 5px;
    width: 100%;
    ${({ fullwidth }) => fullwidth && 'width: 100%;'}

    &:active,
    &:focus {
        border: 1px solid ${colors.grey};
    }

    &::placeholder: {
        color: red;
    }
`
